var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mt-0 mb-5"},[_vm._v("Order #"+_vm._s(_vm.id))]),_vm._v(" "),(_vm.loading)?_c('div',[_vm._v("Loading...")]):_c('div',[_c('order-details'),_vm._v(" "),_c('order-invoice')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }